// src/routes/AppRoutes.jsx
import { Routes, Route } from 'react-router-dom';
import HomePage from '../pages/Home';
import OfficesPage from '../pages/Offices';
import LoginPage from '../pages/Auth/Login';
import OfficePage from '../pages/Office';
import ProfilePage from '../pages/Profile';
import BalancePage from '../pages/Profile/Balance';
import MyPropertiesPage from '../pages/Profile/Properties';
import WishRequestsPage from '../pages/Profile/WishRequests';
import FavoritesPage from '../pages/Profile/Favorites';
import PlansPage from '../pages/Plans';
import PlanCategoryPage from '../pages/PlanCategory';
import SearchPage from '../pages/Search';
import NotificationsPage from '../pages/Notifications';
import NotFoundPage from '../pages/Errors/404';
import OTPPage from '../pages/Auth/Otp';
import { ProtectedRoute } from './ProtectedRoute';
import ContactUsPage from '../pages/Contactus';
import PrivacyPage from '../pages/Privacy';
import TermsPage from '../pages/Terms';
import AboutPage from '../pages/About';
import PasswordPhoneNumberPage from '../pages/Auth/Password/PhoneNumber';
import PasswordOtpPage from '../pages/Auth/Password/Otp';
import PasswordNewPasswordPage from '../pages/Auth/Password/NewPassword';
import MenuPage from '../pages/Menu';
import PropertyPage from '../pages/Property';
import useVisit from '../hooks/useVisit';
import CreatePropertyPage from '../pages/Profile/Properties/create';
import PlanPage from '../pages/Plans/view';
import BannerPage from '../pages/Banner';
import MapSearchPage from '../pages/MapSearch';

export default function AppRoutes() {
  useVisit();

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/password_recovery" element={<PasswordPhoneNumberPage />} />
      <Route path="/password_recovery/otp" element={<PasswordOtpPage />} />
      <Route path="/password_recovery/new" element={<PasswordNewPasswordPage />} />
      <Route path="/otp" element={<OTPPage />} />
      <Route path="/offices" element={<OfficesPage />} />
      <Route path="/office/:id" element={<OfficePage />} />
      <Route path='/property/:id' element={<PropertyPage />} />

      <Route path='/banner/:id' element={<BannerPage />} />

      <Route path="/search" element={<SearchPage />} />
      <Route path="/map-search" element={<MapSearchPage />} />

      <Route path="/menu" element={<MenuPage />} />

      <Route path="/contact" element={<ContactUsPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/about" element={<AboutPage />} />

      <Route path="*" element={<NotFoundPage />} />
      
      <Route element={<ProtectedRoute />}>
        <Route path="/profile" element={<ProfilePage />} />
        <Route path='/plans' element={<PlansPage />} />
        <Route path='/plans/category/:id' element={<PlanCategoryPage />} />
        <Route path='/plans/view/:id' element={<PlanPage />} />
        <Route path="/ad_balance" element={<BalancePage />} />
        <Route path="/my_properties" element={<MyPropertiesPage />} />
        <Route path="/my_properties/create" element={<CreatePropertyPage />} />
        <Route path="/wish_requests" element={<WishRequestsPage />} />
        <Route path="/favorites" element={<FavoritesPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
      </Route>
    </Routes>
  );
}